import $ from 'jquery';
import widgetFactory from '../../../widgetFactory';

import alert from '../../../../Services/confirm';
import deleteElement from './deleteElement';
import OCAPI from '../../../../Services/OCAPI';
import { translate } from '@openclassrooms/translations';

const widgetName = 'coursePartEdit';
const baseClassname = 'js-coursePartEdit';

export default widgetFactory(widgetName, {
  /**
   * @private
   */
  _create() {
    this._super(baseClassname);
    this._createDeleteExerciseWidgets();
  },

  /**
   * @private
   */
  _createDeleteExerciseWidgets() {
    this.getWidgetElement('deleteExercise').each((n, element) => {
      const exerciseId = $(element).data('elementId');

      deleteElement.create(
        {
          confirmMessage: translate('mcq.edit.warning.delete_exercise_confirm'),
          confirmCallback: () => {
            this._handleDeleteExercise(element, exerciseId);
          },
        },
        element
      );
    });
  },

  /**
   *
   * @param {HTMLElement} element
   * @param {number} exerciseId
   * @private
   */
  _handleDeleteExercise(element, exerciseId) {
    const $element = $(element);

    $element.hide();

    OCAPI.exercises
      .delete(exerciseId)
      .then(() => {
        $element.remove();
      })
      .catch(() => {
        $element.show();
        alert(translate('global.error.general_error'));
      });
  },
});

export { baseClassname as className };
